import type { IContextMutationResult } from '@modules/core/services/query/types';
import type {
  ISettingsClickDomainSetDefaultResponse,
  ISettingsClickDomainsSetDefaultPayload,
} from '@modules/general-settings/submodules/click-domains/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_PERMISSIONS,
  SETTINGS_CLICK_DOMAINS_SET_DEFAULT_MUTATION_KEY,
  SETTINGS_CLICK_DOMAINS_SET_DEFAULT_URL,
} from '@modules/general-settings/submodules/click-domains/constants';
import { useToastStore } from '@modules/toast/store';

export default function useSettingsClickDomainsSetDefaultMutation(): IContextMutationResult<
  ISettingsClickDomainSetDefaultResponse,
  Error,
  ISettingsClickDomainsSetDefaultPayload
> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<
    ISettingsClickDomainSetDefaultResponse,
    Error,
    ISettingsClickDomainsSetDefaultPayload
  >({
    mutationKey: [SETTINGS_CLICK_DOMAINS_SET_DEFAULT_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<ISettingsClickDomainSetDefaultResponse>(
      SETTINGS_CLICK_DOMAINS_SET_DEFAULT_URL,
      payload,
      {
        urlParams: {
          id: payload.id,
        },
        permission: ADMIN_GENERAL_SETTINGS_CLICK_DOMAINS_PERMISSIONS.CLICKDOMAINS_EDIT,
      },
    ),
    onSuccess() {
      displayPresetToast('edited');
    },
  });
}
